<mat-toolbar class="subtitulo">Entidade Social</mat-toolbar>
<div class="painel-principal" style="padding: 10px;">
    <div class="painel-consultar">
        <form #formulario="ngForm">
            <div fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="16px" fxFlexFill>

                <mat-icon>search</mat-icon>
                <mat-form-field fxFlex="100%" fxFlexOffset="20px">
                    <mat-label>Selecione uma entidade social</mat-label>
                    <mat-select [(ngModel)]="entidadeSocial" name="entidadeSocial">
                        <mat-option></mat-option>
                        <mat-option *ngFor="let d of entidadesSociais" [value]="d">
                            {{d.empresa.nomeFantasia}}
                        </mat-option>
                    </mat-select>
                </mat-form-field>
            </div>

            <div dir="rtl" class="botoes" fxLayoutGap="20px" style="padding-top: 20px; padding-bottom: 20px;"
                fxFlexFill>

                <button mat-raised-button fxFlex="20%" (click)="consultar()">
                    CONSULTAR
                </button>

                <button mat-raised-button fxFlex="20%" style="padding-right: 20px" (click)="limpar()" route>
                    LIMPAR
                </button>

            </div>
        </form>

        <table *ngIf="mostrarTabela; else tabelaSemDados" mat-table [dataSource]="dataSource" style="margin-top: 20px">

            <ng-container matColumnDef="entidadesocial">
                <th mat-header-cell *matHeaderCellDef> Entidade Social </th>
                <td mat-cell *matCellDef="let element"> {{element.empresa.nomeFantasia}} </td>
              </ng-container>

              <ng-container matColumnDef="cnpj">
                <th mat-header-cell *matHeaderCellDef> CNPJ  </th>
                <td mat-cell *matCellDef="let element"> {{element.empresa.cnpj}} </td>
              </ng-container>
    

              <ng-container matColumnDef="datainiciovinculo">
                <th mat-header-cell *matHeaderCellDef> Data início vinculo</th>
                <td mat-cell *matCellDef="let element"> {{element.dataVinculo | dataSimples}} </td>
              </ng-container>

              <ng-container matColumnDef="datafimvinculo">
                <th mat-header-cell *matHeaderCellDef> Data fim vinculo</th>
                <td mat-cell *matCellDef="let element"> {{element.dataFim | dataSimples}} </td>
              </ng-container>

              <ng-container matColumnDef="ativa">
                <th mat-header-cell *matHeaderCellDef> Ativa </th>
                <td mat-cell *matCellDef="let element"> {{element.empresa.ativa === 'S' ? 'Sim' : 'Não' }} </td>
              </ng-container>


              <ng-container matColumnDef="acoes">
                <th mat-header-cell *matHeaderCellDef> Ações </th>
                <td mat-cell *matCellDef="let element">
                    <button *ngIf="perfilAcesso.deleta"  mat-button (click)="deletar(element)">
                        <mat-icon>delete</mat-icon>
                    </button>
                    <button *ngIf="perfilAcesso.consulta" mat-button (click)="atualizar(element)">
                        <mat-icon>search</mat-icon>
                    </button>
                </td>
            </ng-container>

            <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
            <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
        </table>
        <div [hidden]="!mostrarTabela">
            <mat-paginator [pageSizeOptions]="[5, 10, 20]" showFirstLastButtons></mat-paginator>
        </div>
        <ng-template #tabelaSemDados>
            <div fxLayout="row" fxLayoutAlign="center center" style="padding-top: 20px">
                {{msg}}
            </div>
        </ng-template>

        <div fxLayout="row"  *ngIf="perfilAcesso.insere" fxLayoutAlign="end center" fxLayoutGap="16px" style="padding-top: 50px">
            <div>
                <button matTooltip="Adicionar nova entidade social" mat-fab color="primary"
                    [routerLink]="['/entidadesocial/cadastrar']" routerLinkActive="router-link-active">
                    <mat-icon>add</mat-icon>
                </button>
            </div>
        </div>
    </div>
</div>

